
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Button, Card, CardContent, CardMedia, Container, Divider, Grid, Stack } from '@mui/material';
import MuiMarkdown from 'mui-markdown';

export default function DeleteAccount() {
    return (
        <>
        <Container id = "app" maxWidth = {false}  component='main' sx={{background:'linear-gradient(135deg, #ffab00 0%, #ff6f00 50%, #ff8f00 100%);'}}>
            <Divider sx={{my:8}}></Divider>
            <Grid container columns={12} sx={{pt:8}}>
                <Grid item xs={1} md ={1} sm={1} align="left" />  
                
                <Grid item xs={10} md ={5} sm={5} align="left" >  
                    <Stack spacing={2} >
                        <Typography component="p"  variant="h3" color="black" sx={{fontWeight:'bolder'}} >
                        Never Wait Parking Again
                        </Typography>
                        <Typography variant="body1" gutterBottom color="black">
                        Say goodbye to circling the block — find, reserve, and access your parking spot instantly with our smart, automated system.
                        </Typography>
                    </Stack> 
                </Grid>

                <Grid item xs={10} md ={5} sm={5} align="right" >  
                    <img
                        width="296"
                        height="409" 
                        src="https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Fhand_app.png?alt=media&token=364790ef-d870-4053-bbc7-c0189fca4eb7"
                        alt="Live from space album cover"
                    />            
                </Grid>
                
                <Grid item xs={1} md ={1} sm={1} align="left" />  
            </Grid>
        </Container>

        <Container id = "app" maxWidth = {"xl"}  component='main' sx={{py:8}}>
        <Typography component="p" variant="h4"sx={{fontWeight:'bolder'}}>
        Download Our App

            </Typography>
            <Grid container columns={12}>
                <Grid item xs={12} md ={12} sm={12} align="center" alignContent={"center"} >  
                    <img
                        width="155"
                        height="64" 
                        src="https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/media%2Fbadges%2Fgetiton_apple.png?alt=media&token=2b682692-6b20-48ed-8522-310cc3d8ed08"
                        alt="Live from space album cover"
                    />            
                     <img
                        width="155"
                        height="64" 
                        src="https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/media%2Fbadges%2Fgeiton_google.png?alt=media&token=c317e890-ccba-49f2-9a83-fda3525a932c"
                        alt="Live from space album cover"
                    />  
                </Grid>
            </Grid>
        </Container>


        <Container id = "app" maxWidth = {"xl"}  component='main'>
            <Divider sx={{my:8}}></Divider>
            <Typography component="p" variant="h4"sx={{fontWeight:'bolder', mb:2}}>
            How can I delete my CQurity Access account?

            </Typography>

             <MuiMarkdown>
                { 'We’re sad to see you go! Hit us up via our [Help Center](/help-center) with the email address associated with your account and we’ll help you out.'}

            </MuiMarkdown>
        </Container>
        </>
    );
}